import React from "react";
import "../../css/components/controls/HrnbSwitch.css";

export default function HrnbSwitch({
                                       label,
                                       checked,
                                       onChange,
                                       disabled = false,
                                       className = "",
                                       error = "",
                                       hint = "",
                                       ...props
                                   }) {
    return (
        <label className={`hrnb-switch-wrap ${className} ${disabled ? "hrnb-switch--disabled" : ""}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={e => onChange(e.target.checked)}
                disabled={disabled}
                className="hrnb-switch-input"
                {...props}
            />
            <span className="hrnb-switch-slider" />
            {label && <span className="hrnb-switch-label">{label}</span>}
            {error
                ? <div className="hrnb-switch-error">{error}</div>
                : hint && <div className="hrnb-switch-hint">{hint}</div>
            }
        </label>
    );
}
